import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import Drawer from "../mui/Drawer";
import CloseIconSrc from "../../assets/FinFactor/CloseIcon.svg";

const ConsentDrawer = ({
  open,
  onClose,
  title,
  listTitle,
  buttonText,
  onButtonClick,
  isLoading,
  children,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ zIndex: 9999 }}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 600, md: 700 },
          backgroundColor: "#13172a",
          color: "white",
          p: { xs: 2, md: 4 },
          backgroundImage: "none",
        },
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Typography variant="h5" fontWeight="bold">
          {title}
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <img src={CloseIconSrc} alt="Close" />
        </IconButton>
      </Box>

      {/* Sub-header with Action button */}
      {(listTitle || buttonText) && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          {listTitle && (
            <Typography variant="h6" fontWeight="bold">
              {listTitle}
            </Typography>
          )}
          {buttonText && (
            <Button
              variant="contained"
              onClick={onButtonClick}
              disabled={isLoading}
              sx={{
                backgroundColor: "#06B6D4", // Cyan/Light blue matching Figma
                textTransform: "none",
                borderRadius: "8px",
                px: 3,
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#0891B2",
                },
              }}
            >
              {isLoading ? "Please Wait..." : buttonText}
            </Button>
          )}
        </Box>
      )}

      {children}
    </Drawer>
  );
};

export default ConsentDrawer;
